import { observer } from "mobx-react-lite";
import { SwipeUser } from "../models/api/SwipeUser";
import { rootStore } from "../StApp";
import insta_icon from '../assets/insta-ico.svg'
import linkedin_logo from '../assets/linkedin-ico.svg'
import { DateDetailProps } from "./DateDetailModal";
import React, { useRef } from "react";
import { VoiceIntro } from "./VoiceIntro";
import { useProfileImage } from "../customHooks/useProfileImage";
import useIsVisible from "../customHooks/useIsVisible";
import { AppPromotion } from "./AppPromotion";
import { AnonMsgBox } from "./AnonMsgBox";

const ProfileHead = observer(({ likeButton = true, ...props }: DateDetailProps) => {

    const user = props.user

    const { imgUrl } = useProfileImage(user.uid, 0, props.mainImgUrl)


    function toggleSelection() {
        rootStore.dateshipStore.toggleLike(props.user.uid)
    }


    return (<section style={{
        backgroundImage: `url(${imgUrl})`,
        width: '100%',
        height: 500,
        backgroundSize: 'cover',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        position: 'relative'
    }}>
        <div style={{
            position: 'absolute',
            bottom: 10,
            left: 10,
            color: 'white'
        }}>
            <div className='flex-row center-both'>
                <h2 style={{
                    marginBottom: 0,
                    marginTop: 0
                }}>{user.name} {user.age && <span>,</span>} {user.age}</h2>
                <span className="material-icons" style={{
                    marginLeft: 2,
                    color: 'green'
                }}>
                    verified
                </span>
            </div>
            <VoiceIntro uid={user.uid} />
        </div>
        <span className="material-icons-round"
            style={{
                position: 'absolute',
                bottom: 20,
                right: 10,
                fontSize: 50,
                color: rootStore.dateshipStore.likedUids.includes(user.uid) ? 'red' : 'gray',
                display: likeButton == false ? 'none' : 'initial'

            }}
            onClick={toggleSelection}
        >
            favorite
        </span>
    </section>);
})

function BioSection(props: { user: SwipeUser }) {

    const user = props.user

    return (<section className='flex-column' style={{
        minHeight: 100,
        backgroundColor: '#fed4ff',
        padding: '20px 10px'
    }}>
        <h4 style={{
            color: 'green'
        }}>Verified with</h4>
        <div className='flex-row' style={{
            marginBottom: 10
        }}>
            {user.ig && <img src={insta_icon} alt="" style={{
                width: 25,
                height: 25
            }} />}
            {user.linked_in && <img src={linkedin_logo} alt="" style={{
                width: 25,
                height: 25
            }} />}
            {user.video && <span className="material-icons-round" style={{
                fontSize: 25
            }}>
                video_call
            </span>}
        </div>
        <h4 style={{
            color: 'gray'
        }}>About Me</h4>
        <h3 style={{whiteSpace:'pre-wrap'}} >{user.bio}
        </h3>
    </section>);
}

function SubImage(props: { mainImgUrl: string, index: number, user: SwipeUser }) {

    const { imgUrl } = useProfileImage(props.user.uid, props.index, props.mainImgUrl)

    return (imgUrl ? <section style={{
        backgroundImage: `url(${imgUrl})`,
        width: '100%',
        height: 500,
        backgroundSize: 'cover'
    }}>
    </section> : null);
}

function PromptSection(props: { q: string, a: string }) {

    if (props.q.length < 1)
        return null

    return (<section className='flex-column' style={{
        minHeight: 50,
        backgroundColor: '#fed4ff',
        padding: '20px 10px'
    }}>
        <h4 style={{
            color: 'gray'
        }}>{props.q}</h4>
        <h3 style={{ marginTop: 5 }} >{props.a}
        </h3>
    </section>);
}



function LocationSection(props: { user: SwipeUser }) {

    return (<section className='flex-column' style={{
        minHeight: 100,
        backgroundColor: '#fed4ff',
        padding: '20px 10px'
    }}>
        {props.user.currentLoc && <>
            <h4 style={{
                color: 'gray',
                marginLeft: 10
            }}>{props.user.name}'s Current Location</h4>
            <div className='flex-row center-align flex-start'>
                <span className="material-icons-round">
                    location_on
                </span>
                <h3 style={{
                    margin: 0
                }}>{props.user.currentLoc.state}, {props.user.currentLoc.country}</h3>
            </div>
        </>}
        {props.user.fromPlace && <div>
            <h4 style={{ color: 'gray', marginLeft: 10 }} >From</h4>
            <div style={{ backgroundColor: '#ce8bce', borderRadius: 25, padding: 10, alignSelf: 'flex-start', display:'inline-block' }} >
                <h3 style={{ margin: 0, alignSelf: 'flex-start' }} >{props.user.fromPlace}</h3>
            </div>
        </div>}
    </section>);
}



export function ProfileBody(props: { user: SwipeUser, data: DateDetailProps }) {

    const elemRef = useRef(null);
    const isVisible = useIsVisible(elemRef);

    return (<div ref={elemRef} >
        {isVisible? <div>
            <SubImage mainImgUrl={props.data.mainImgUrl} user={props.user} index={1} key='1s'></SubImage>
            <PromptSection q={props.user.prompts.q1} a={props.user.prompts.a1} key={1}></PromptSection>
            <SubImage mainImgUrl={props.data.mainImgUrl} user={props.user} index={2} key='2s'></SubImage>
            <PromptSection q={props.user.prompts.q2} a={props.user.prompts.a2} key={2}></PromptSection>
            <SubImage mainImgUrl={props.data.mainImgUrl} user={props.user} index={3} key='3s'></SubImage>
            <PromptSection q={props.user.prompts.q3} a={props.user.prompts.a3} key={3}></PromptSection>
            <LocationSection user={props.user}></LocationSection>
        </div>: <div style={{height: 100, width: 10}} />}

    </div>);
}

function DemoComp(props: { inViewport: boolean, forwardedRef: any }) {
    const { inViewport, forwardedRef } = props;
    return <div ref={forwardedRef} style={{ height: 500, width: 200 }} ></div>
}
function DemoComp2() {

    return <div style={{ height: 500, width: 200, backgroundColor: 'green' }} ></div>
}


export function DateDetaisBox(props: { user: SwipeUser, data: DateDetailProps, style: React.CSSProperties }) {

    return (<div style={props.style}>
        <ProfileHead user={props.user} mainImgUrl={props.data.mainImgUrl} likeButton={props.data.likeButton} ></ProfileHead>
        <BioSection user={props.user}></BioSection>
        <ProfileBody data={props.data} user={props.user} />
        <AnonMsgBox data={{userUid: props.user.uid, disabled: !props.user.anonMsg!}}  />
        <AppPromotion/>

    </div>);
}